<div class="theme_bg">
<div class="container nopad">
    <app-booking-steps [travellers]="true"></app-booking-steps>
    <h3 _ngcontent-vdt-c225 class="review_txt">Review Your Booking</h3>
    <div class="mb-2 mt-2" style="border:none;">
        <div class="card-body pb-3">
            <app-booking-flight-detail [flight]="flight" [traveller]="traveller"></app-booking-flight-detail>
            <div class="row mobile_row">
                <div class="col-md-8 col-lg-8 nopad">
                    <div *ngFor="let iList of flight.FlightDetails.Details" class="">
                        <div *ngFor="let list of iList; let i = index" style="box-shadow: 0px 1px 16px #ddd;"
                            class="col-md-12 col-lg-12 mt-3 cardList rounded border card">
                            <div class="cardListHead">
                                <div class="row">
                                    <div class="col-md-2 col-5 nopad">
                                        <i class="fal fa-plane"></i> <b>{{list.Origin.CityName}}
                                            ({{list.Origin.AirportCode}})</b>
                                    </div>
                                    <div class="col-md-1 col-2 text-center nopad"><i class="fas fa-exchange-alt"></i>
                                    </div>
                                    <div class="col-md-2 col-5 nopad">
                                        <b>{{list.Destination.CityName}} ({{list.Destination.AirportCode}})</b>
                                    </div>
                                    <div class="col-md-3 col-12 nopad">
                                        <b>{{list.Duration}}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="cardListBody">
                                <div style="display: table-row">
                                    <div class="mobile_details_bagg"
                                        style="width: 600px; display: table-cell; padding: 10px 0px;">
                                        <div class="cellStyles" style="float: left;">
                                            <span style="color: #001D46;font-weight: 600;">Departure :
                                            </span> &nbsp;{{list.Origin.DateTime | date:'d MMM y, EEE'}}
                                        </div>
                                        <div class="clearfix"></div>
                                        <div style="display: table; padding: 5px 0px;">
                                            <div class="colImgStyle">
                                                <img class="rounded" style="max-width: 95px; height: 40px;"
                                                    [src]="[airline_logo + list.OperatorCode + '.svg']" alt="">
                                            </div>
                                            <div class="colImgStyle">
                                                <span style="font-size: 14px;color: #082B3A;">
                                                    {{ list.OperatorName + ' (' + list.OperatorCode + ')' }}</span>
                                                <br><small>{{list.CabinClass}}</small>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-3 col-5 nopad">
                                                    <div class="colTimeStyle">
                                                        <span style="color: #189AD3;font-size: 20px;">
                                                            {{ list.Origin.DateTime | date: 'HH:mm' }}</span>
                                                        <br><small>{{list.Origin.AirportName}} <br>
                                                            Terminal:   ({{list.Origin.Terminal}})</small>
                                                    </div>
                                                </div>
                                                <div class="col-md-1 col-2 nopad">
                                                    <div class="colTimeStyle text-center"><span
                                                            style='font-size:20px;'>&#8594;</span></div>
                                                </div>
                                                <div class="col-md-3 col-5 nopad">
                                                    <div class="colTimeStyle">
                                                        <span style="color: #189AD3;font-size: 20px;">{{
                                                            list.Destination.DateTime | date: 'HH:mm' }}</span>
                                                        <br><small>{{list.Destination.AirportName}} <br>
                                                           Terminal: ({{list.Destination.Terminal}})</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mobile_details_bagg mobile_font border_left"
                                        style="display: table-cell; vertical-align: top;">
                                        <div class="mobile_nopad" style="padding: 12px;">
                                            <h5 style="font-size: 18px;">Baggage details</h5>
                                            <i class="fa fa-suitcase"></i> &nbsp; Check In:
                                            {{getBaggage(list.Attr.Baggage)}}<br />
                                            <i class="fa fa-suitcase"></i> &nbsp; Cabin:
                                            {{getBaggage(list.Attr.CabinBaggage)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-3 rounded border p-2 search_again">
                        <a (click)="searcAgain()"> <i class="fal fa-angle-left"></i>
                            &nbsp; Search Again</a>
                    </div>
                    <div class="mt-3 float-right">
                        <button class="btn btn-primary continue" type="button" (click)="onContinue()">Continue</button>
                    </div>
                    <div class="clearfix"></div>
                </div>
                <div class="col-md-4 col-lg-4 mt-3 padlt">
                    <app-review-fare-summary [flight]="flight"></app-review-fare-summary>
                </div>
            </div>
            <!-- <ngx-loading [show]="loading"
        [config]="{primaryColour: primaryColour, secondaryColour: secondaryColour, tertiaryColour: primaryColour, backdropBorderRadius: '3px',fullScreenBackdrop:true}"
        [template]="loadingTemplate"></ngx-loading> -->
        </div>
    </div>
    </div>
</div>